import { render, staticRenderFns } from "./HistoryQuota.vue?vue&type=template&id=39891e42&scoped=true&"
import script from "./HistoryQuota.vue?vue&type=script&lang=js&"
export * from "./HistoryQuota.vue?vue&type=script&lang=js&"
import style0 from "./HistoryQuota.vue?vue&type=style&index=0&id=39891e42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39891e42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
